import { Box, useTheme } from '@mui/material';
import Cookies from 'js-cookie';
import { ReactNode, useState } from 'react';
import Turnstile from 'react-turnstile';
import { sleep } from 'src/utils/helpers/utilities';

const TurnstileCaptcha = ({ children }: { children: ReactNode }) => {
  const { zIndex } = useTheme();
  const sitekey = process.env.REACT_APP_CLOUDFLARE_TURNSTILE_KEY;
  if (!sitekey) {
    console.error('Missing REACT_APP_CLOUDFLARE_TURNSTILE_KEY');
    return null;
  }
  const [token, setToken] = useState<string>(() => Cookies.get('turnstile-token') || '');
  const [isPassCaptcha, setIsPassCaptcha] = useState(() => !!Cookies.get('turnstile-token'));

  const onSuccess = async (token: string) => {
    await sleep(1500);
    Cookies.set('turnstile-token', token, { expires: 1 });
    setToken(token);
    setIsPassCaptcha(true);
  };

  const onExpire = () => {
    Cookies.remove('turnstile-token');
    setToken('');
    setIsPassCaptcha(false);
  };

  if (!isPassCaptcha) {
    return (
      <Box
        sx={{
          position: 'fixed',
          zIndex: zIndex.drawer * 2,
          left: '50%',
          top: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <Turnstile onExpire={onExpire} cData={token} sitekey={sitekey} onSuccess={onSuccess} />
      </Box>
    );
  }
  return <>{children}</>;
};

export default TurnstileCaptcha;
